/**
 * Facebook page leads on/off (olympus-functions issue 04, B4 decisions Q11–Q19, 2026-10-09).
 * Takes a record of the Meta pages entity (systemOotbMetaPages) and turns its leads on or off for
 * THIS workspace only: Meta keeps sending while another workspace still wants the page, and this
 * workspace's leads are kept raw, unprocessed. Same shape and generator rules as delete_record
 * (record-blocks.ts). No Angular imports — this file is compiled into the Drydock bundle.
 */
import * as Blockly from 'blockly-tradais';
import { javascriptGenerator } from 'blockly-tradais/javascript';

const COLOUR = '#1877f2';
export const META_PAGES_ENTITY_ID = 'systemOotbMetaPages';

export function registerMetaBlocks(): void {
  (Blockly as any).Blocks['meta_page_subscription'] = {
    init: function () {
      this.appendValueInput('PAGE').setCheck('ENTITY')
        .appendField(new (Blockly as any).FieldDropdown([['turn off', 'unsubscribe'], ['turn on', 'subscribe']]), 'ACTION')
        .appendField('Facebook page leads for');
      this.setInputsInline(false);
      this.setOutput(true, 'String');
      this.setColour(COLOUR);
      this.setTooltip(
        "Turns a connected Facebook page's leads off or back on for this workspace. Give it a record of the " +
        "Facebook pages entity. Other workspaces using the same page keep getting its leads. " +
        "Returns 'success' or an error.");
      this.setHelpUrl('');
    },
  };
  (javascriptGenerator as any).forBlock['meta_page_subscription'] = function (block: any) {
    const action = block.getFieldValue('ACTION') === 'subscribe' ? 'subscribe' : 'unsubscribe';
    const child = block.getInput('PAGE')?.connection?.targetBlock?.();
    const pageCode = (javascriptGenerator as any).valueToCode(block, 'PAGE', (javascriptGenerator as any).ORDER_ATOMIC) || '';
    // As delete_record: an unpicked get-entity block hands back the literal 'NAN_ENTITY_VARIABLE' — treat it as nothing picked.
    if (pageCode === 'NAN_ENTITY_VARIABLE' || pageCode === '') {
      return [`await this.metaPageSubscriptionFromVariable(null, '${action}')`, (javascriptGenerator as any).ORDER_ATOMIC];
    }
    // As delete_record: a row picked out of a list is raw; wrap it with the list's own entityId.
    if (child?.type === 'set_entity_variable_by_index_of_entity_list') {
      const list = (javascriptGenerator as any).valueToCode(child, 'VALUE', (javascriptGenerator as any).ORDER_ATOMIC) || '';
      const entityIdExpr = list.endsWith('.data') ? list.slice(0, -'.data'.length) + '.entityId' : 'null';
      return [`await this.metaPageSubscriptionFromVariable({ entityId: ${entityIdExpr}, data: ${pageCode} }, '${action}')`, (javascriptGenerator as any).ORDER_ATOMIC];
    }
    return [`await this.metaPageSubscriptionFromVariable(${pageCode}, '${action}')`, (javascriptGenerator as any).ORDER_ATOMIC];
  };
}
